import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.grey[50],
    color: theme.palette.grey[800],
    boxShadow: theme.shadows[3],
    fontSize: '13px',
    lineHeight: '18px',
    opacity: 1,
    fontWeight: 400,
    padding: '0.5rem 0.75rem',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.grey[50],
  },
}));

export default LightTooltip;
